<div id="enrollment-agreement">
  <div class="page1 p-3">

    <!-- Tracking block + enrollment type -->
    <div class="d-flex justify-content-between small mb-2">
      <div>
        <p class="mb-0">Source: ___________</p>
        <p class="mb-0">D&eacute;mo par: _________</p>
        <p class="mb-0">Assign&eacute; &agrave;: _________</p>
        <p class="mb-0">Date: <span class="fw-bold">{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
      </div>
      <div class="text-end">
        <p class="mb-0">Ori. <span class="border border-dark d-inline-block align-middle ms-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.original ? '#000' : '#fff'"></span></p>
        <p class="mb-0">Ext. <span class="border border-dark d-inline-block align-middle ms-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.extension ? '#000' : '#fff'"></span></p>
        <p class="mb-0">Ren. <span class="border border-dark d-inline-block align-middle ms-1" style="width:12px;height:12px;" [style.background]="enrollmentTypeState.renewal ? '#000' : '#fff'"></span></p>
      </div>
    </div>

    <!-- Header -->
    <p class="text-center fw-bold mb-0">&Eacute;cole de danse Arthur Murray Franchis&eacute;e</p>
    <p class="text-center small mb-0">
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }},
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }},
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}
    </p>
    <p class="text-center small mb-2">T&eacute;l.: {{ this.studioInformationConfig?.field_studio_phone_number?.[0]?.value }}</p>

    <h4 class="text-center fw-bold text-decoration-underline mb-1">CONTRAT DE SERVICES D'ENSEIGNEMENT DE DANSE</h4>
    <p class="fst-italic fw-bold text-decoration-underline mb-3">Instruction de Danse Sociale</p>

    <!-- Student 1 -->
    <div class="small mb-3">
      <p class="mb-1">1. <span class="fw-bold">Nom de l'&eacute;l&egrave;ve:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:300px;">{{ entityData?.['field_student']?.['title'] || '' }}</span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">Adresse:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:280px;">{{ primaryContact?.field_address?.address_line1 || '' }}</span>,
        <span class="fw-bold">Apt.</span> <span class="border-bottom d-inline-block px-2" style="min-width:60px;"></span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">Ville:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:220px;">{{ primaryContact?.field_address?.locality || '' }}</span>,
        <span class="fw-bold">Code Postal:</span> <span class="border-bottom d-inline-block px-2" style="min-width:100px;">{{ primaryContact?.field_address?.postal_code || '' }}</span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">T&eacute;l. R&eacute;sidence:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:150px;"></span>
        <span class="fw-bold">T&eacute;l. Bureau:</span> <span class="border-bottom d-inline-block px-2" style="min-width:150px;"></span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">Cell:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:150px;">{{ primaryContact?.field_cell_phone || '' }}</span>
        <span class="fw-bold">Courriel:</span> <span class="border-bottom d-inline-block px-2" style="min-width:200px;">{{ primaryContact?.field_email || '' }}</span></p>
    </div>

    <!-- Student 2 (couples) -->
    <div class="small mb-3">
      <p class="mb-1">2. <span class="fw-bold">Nom de l'&eacute;l&egrave;ve:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:300px;">{{ secondaryContact ? ((secondaryContact.field_first_name || '') + ' ' + (secondaryContact.field_last_name || '')) : '' }}</span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">Adresse:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:280px;">{{ secondaryContact?.field_address?.address_line1 || '' }}</span>,
        <span class="fw-bold">Apt.</span> <span class="border-bottom d-inline-block px-2" style="min-width:60px;"></span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">Ville:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:220px;">{{ secondaryContact?.field_address?.locality || '' }}</span>,
        <span class="fw-bold">Code Postal:</span> <span class="border-bottom d-inline-block px-2" style="min-width:100px;">{{ secondaryContact?.field_address?.postal_code || '' }}</span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">T&eacute;l. R&eacute;sidence:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:150px;"></span>
        <span class="fw-bold">T&eacute;l. Bureau:</span> <span class="border-bottom d-inline-block px-2" style="min-width:150px;"></span></p>
      <p class="mb-1 ms-3"><span class="fw-bold">Cell:</span>
        <span class="border-bottom d-inline-block px-2" style="min-width:150px;">{{ secondaryContact?.field_cell_phone || '' }}</span>
        <span class="fw-bold">Courriel:</span> <span class="border-bottom d-inline-block px-2" style="min-width:200px;">{{ secondaryContact?.field_email || '' }}</span></p>
    </div>

    <!-- Course description -->
    <p class="fst-italic fw-bold text-decoration-underline mb-1">Description des cours</p>
    <p class="small mb-2">L'(Les) &eacute;l&egrave;ve(s) soussign&eacute;(e)s consent(ent) &agrave; suivre un certain nombre de sessions d'instruction de danse comme suit:</p>

    <table class="table table-bordered text-center small mb-3">
      <tr>
        <td class="fw-bold"># de le&ccedil;ons priv&eacute;es</td>
        <td class="fw-bold"># de cours de groupe</td>
        <td class="fw-bold"># de cours de soir&eacute;es de pratique</td>
        <td class="fw-bold">Nombre total de sessions</td>
        <td class="fw-bold">Frais de scolarit&eacute;</td>
        <td class="fw-bold">GST<br>(5 %)</td>
        <td class="fw-bold">TPS<br>(9.975 %)</td>
        <td class="fw-bold">Total</td>
      </tr>
      <tr>
        <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
        <td></td>
        <td></td>
        <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
        <td>{{ getSubtotal() | number:'1.2-2' }}$</td>
        <td>{{ getGstAmount() | number:'1.2-2' }}$</td>
        <td>{{ getQstAmount() | number:'1.2-2' }}$</td>
        <td>{{ calculateTotalTuition() | number:'1.2-2' }}$</td>
      </tr>
    </table>

    <!-- Payment terms -->
    <p class="fst-italic fw-bold text-decoration-underline mb-1">Modalit&eacute;s de paiements</p>
    <p class="small mb-2">L'&eacute;l&egrave;ve consentira &agrave; payer le total des frais exigibles comme suit:
      <span class="fw-bold border-bottom px-2">{{ getPaidToday() | number:'1.2-2' }}$</span> aujourd'hui, et le solde en
      <span class="fw-bold border-bottom px-2">{{ remainingInstallments.length || '___' }}</span> versements &eacute;gaux de
      <span class="fw-bold border-bottom px-2">{{ (remainingInstallments.length && remainingAmountsEqual) ? ((remainingInstallments[0].amount | number:'1.2-2') + '$') : '____________$' }}</span>
      &agrave; chaque
      <span class="fw-bold border-bottom px-2">{{ lessonsPerPayment || '___' }}</span> le&ccedil;ons priv&eacute;es ou
      <span class="fw-bold border-bottom px-2">{{ cadenceFrench || '_______________________' }}</span>.
      Dans le cas d'un paiement en entier, l'&eacute;l&egrave;ve a jusqu'&agrave; ______ mois pour demander un remboursement.
      Pour l'&eacute;l&egrave;ve qui utilise <strong>2</strong> cours priv&eacute;s par mois, les cours de groupe et les soir&eacute;es de pratique sont illimit&eacute;s.
      Les cours de groupes et soir&eacute;es de pratiques se terminent lorsque les cours priv&eacute;s sont compl&eacute;t&eacute;s.</p>

    <div *ngIf="isInstallmentAgreement && remainingInstallments.length && !remainingAmountsEqual" class="mb-3" style="max-width:420px;">
      <table class="table table-bordered text-center small mb-0">
        <tr><th>Versement</th><th>Montant</th><th>Date</th></tr>
        <tr *ngFor="let payment of remainingInstallments; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ payment.amount | number:'1.2-2' }}$</td>
          <td>{{ payment.date ? (payment.date | date) : '' }}</td>
        </tr>
      </table>
    </div>

    <!-- Fixed terms -->
    <p class="small mb-2">Les r&egrave;glements d'instruction ayant trait aux &eacute;l&egrave;ves, et affich&eacute;s dans l'&eacute;cole font partie du pr&eacute;sent contrat. Il est convenu que l'&eacute;cole assurera le nombre de sessions d'instruction indiqu&eacute;es ci-haut, conform&eacute;ment aux m&eacute;thodes Arthur Murray et qu'&agrave; cette fin les &eacute;l&egrave;ves disposeront des locaux et du personnel. L'&eacute;cole s'engage &agrave; fournir un instructeur qualifi&eacute; pour chacune des le&ccedil;ons pr&eacute;vues au programme. Toutefois, l'&eacute;cole se r&eacute;serve le droit d'assigner ou de remplacer tout instructeur selon les besoins op&eacute;rationnels, sans que cela ne constitue une modification au pr&eacute;sent contrat.</p>

    <p class="small fw-bold mb-2">Toute le&ccedil;on priv&eacute;e doit &ecirc;tre annul&eacute;e ou report&eacute;e au moins vingt-quatre (24) heures avant l'heure pr&eacute;vue. &Agrave; d&eacute;faut, la le&ccedil;on pourra &ecirc;tre consid&eacute;r&eacute;e comme suivie et d&eacute;duite du programme, sauf circonstances exceptionnelles accept&eacute;es par l'&eacute;cole.</p>

    <p class="small fw-bold mb-2">UNE (1) LE&Ccedil;ON PRIV&Eacute;E CORRESPOND &Agrave; UNE P&Eacute;RIODE DE QUARANTE-CINQ (45) MINUTES, INCLUANT LE TEMPS DE TRANSITION ENTRE LES RENDEZ-VOUS.</p>

    <p class="small fw-bold mb-2">Les articles suivants sont extraits de la Loi sur la protection du consommateur:</p>

    <!-- Signatures. The back page's own signature lines stay blank (embedded
         back-page images are disabled pending legal approval), so the captured
         signatures are shown here on the front page, as the other templates do. -->
    <div *ngIf="displaySigned" class="mt-3">
      <p class="small mb-3">SIGN&Eacute; &agrave;
        <span class="border-bottom px-2">{{ studioInformationConfig?.field_studio_address?.[0]?.locality || '' }}</span>,
        Qu&eacute;bec, Canada, le
        <span class="border-bottom px-3">{{ (entityData?.['field_sale_date']?.value || entityData?.['field_sale_date']) | date }}</span></p>

      <div class="row">
        <div class="col-6">
          <div class="border-bottom" style="height:34px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
                 class="img-fluid" style="max-height:32px;"
                 [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
          </div>
          <p class="small fw-bold mb-4">Signature autoris&eacute;e de l'&eacute;cole</p>

          <div class="border-bottom" style="height:34px;"></div>
          <p class="small fw-bold mb-0">V&eacute;rifi&eacute; par</p>
        </div>

        <div class="col-6">
          <div class="d-flex align-items-end">
            <span class="small fw-bold me-2 pb-1">Par:&nbsp;1)</span>
            <div class="border-bottom flex-grow-1" style="height:34px;">
              <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
                   class="img-fluid" style="max-height:32px;"
                   [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
            </div>
          </div>
          <p class="small fw-bold mb-4" style="margin-left:2.5rem;">Signature de l'&eacute;l&egrave;ve</p>

          <div class="d-flex align-items-end">
            <span class="small fw-bold me-2 pb-1">Par:&nbsp;2)</span>
            <div class="border-bottom flex-grow-1" style="height:34px;"></div>
          </div>
          <p class="small fw-bold mb-0" style="margin-left:2.5rem;">Signature de l'&eacute;l&egrave;ve</p>
        </div>
      </div>
    </div>

  </div>

  <!-- The Loi sur la protection du consommateur back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the other templates. -->
</div>
